
export class ModelBase {
  id: string | number;
  code: string;
  timeStamp: Date;
  status: string;
  isProcessing: boolean;
  isSelected: boolean;
}





// WEBPACK FOOTER //
// /opt/build/repo/src/app/common/contracts/base.model.ts